<template>
	<div>
		<ul class="nav nav-tabs" id="myTabPolizasOportunidades" role="tablist">
		 	<li class="nav-item">
		    	<a class="nav-link active" id="detalles-tab" data-toggle="tab" href="#detalles" role="tab" aria-controls="detalles" aria-selected="true">Detalles</a>
		  	</li>

		  	<li class="nav-item">
		    	<a class="nav-link" id="bienes-tab" data-toggle="tab" href="#bienes" role="tab" aria-controls="bienes" aria-selected="false">
		    		Bienes asegurados
		    		<span id="badge-bienes" class="badge badge-light">
                        0
                    </span>
		    	</a>
		  	</li>

		  	<li class="nav-item">
		    	<a class="nav-link" id="endosos-tab" data-toggle="tab" href="#endosos" role="tab" aria-controls="endosos" aria-selected="false">
		    		Endosos
		    		<span id="badge-endosos" class="badge badge-light">
                        0
                    </span>
		    	</a>
		  	</li>

		  	<li class="nav-item">
		    	<a class="nav-link" id="cobros-programados-tab" data-toggle="tab" href="#cobros-programados" role="tab" aria-controls="cobros-programados" aria-selected="false">
		    		Cobros Programados
		    		<span id="badge-cobros-programados" class="badge badge-light">
                        0
                    </span>
		    	</a>
		  	</li>

		  	<li class="nav-item">
		    	<a class="nav-link" id="cobros-realizados-tab" data-toggle="tab" href="#cobros-realizados" role="tab" aria-controls="cobros-realizados" aria-selected="false">
		    		Cobros Realizados 
		    		<span id="badge-cobros-realizados" class="badge badge-light">
                        0
                    </span>
		    	</a>
		  	</li>

		  	<li class="nav-item">
		    	<a class="nav-link" id="logs-tab" data-toggle="tab" href="#logs" role="tab" aria-controls="logs" aria-selected="false">
		    		Historial 
		    		<span id="badge-polizas-log" class="badge badge-light">
                        0
                    </span>
		    	</a>
		  	</li>
		</ul>
		<div class="tab-content" id="myTabPolizasOportunidadesContent">
			<div class="tab-pane fade show active" id="detalles" role="tabpanel" aria-labelledby="detalles-tab">
				<preloader v-if="loading"></preloader>
				<div class="card-group">
	    			<div class="card col-md-9 p-0">
	    				<div class="card-body">
	    					<div class="form-row">
				    			<div class="col-md-4 mb-3" v-if="form.oportunidad">
				    				<label>Oportunidad:</label>
				    				<catalogo-oportunidades 
				    					:disabled="true"
				    					v-model="form.oportunidad">
				    				</catalogo-oportunidades>
						            <div v-if="errors && errors.oportunidad" 
						            	class="text-danger">
				                        {{ errors.oportunidad[0] }}
				                    </div>
				    			</div>

				    			<div class="col-md-4 mb-3">
				    				<label>Aseguradora:</label>
				    				<catalogo-aseguradoras 
				    					:disabled="disabled"
				    					v-model="form.aseguradora">
				    				</catalogo-aseguradoras>
						            <div v-if="errors && errors.aseguradora" 
						            	class="text-danger">
				                        {{ errors.aseguradora[0] }}
				                    </div>
				    			</div>

				    			<div class="col-md-4 mb-3">
				    				<label>Vendedor:</label>
				    				<catalogo-vendedores 
				    					:disabled="disabled"
				    					v-model="form.vendedor">
				    				</catalogo-vendedores>
						            <div v-if="errors && errors.vendedor" 
						            	class="text-danger">
				                        {{ errors.vendedor[0] }}
				                    </div>
				    			</div>
				    			
				    			<div class="col-md-4 mb-3">
				    				<label>Cliente:</label>
				    				<catalogo-clientes 
				    					:disabled="disabled"
				    					v-model="form.cliente">
				    				</catalogo-clientes>
						            <div v-if="errors && errors.cliente" 
						            	class="text-danger">
				                        {{ errors.cliente[0] }}
				                    </div>
				    			</div>

				    			<div class="col-md-6 mb-3">
				    				<label>Producto:</label>
				    				<catalogo-productos 
				    					:disabled="disabled"
				    					v-model="form.producto">
				    				</catalogo-productos>
						            <div v-if="errors && errors.productos" 
						            	class="text-danger">
				                        {{ errors.productos[0] }}
				                    </div>
				    			</div>

				    			<div class="col-md-6 mb-3">
				    				<label>Tipo de Póliza:</label>
				    				<catalogo-tipos-polizas 
				    					:disabled="disabled"
				    					v-model="form.tipoPoliza">
				    				</catalogo-tipos-polizas>
				    				<div v-if="errors && errors.tipo_poliza" 
						            	class="text-danger">
				                        {{ errors.tipo_poliza[0] }}
				                    </div>
				    			</div>

				    			<div class="col-md-6 mb-3">
				    				<label>Canal de Pago:</label>
				    				<catalogo-formas-pagos 
				    					:disabled="disabled"
				    					v-model="form.formaPago">
				    				</catalogo-formas-pagos>
						            <div v-if="errors && errors.forma_pago" class="text-danger">
				                        {{ errors.forma_pago[0] }}
				                    </div>
				    			</div>

								<div class="col-md-3 mb-3">
				    				<label for="vigencia_ini">
				    					Fecha Vigencia Inicial:
				    				</label>
				    				<date-picker 
				    					id="vigencia_ini"
				    					:disabled="disabled"
				    					class="form-control-sm"
				    					v-model="form.vigenciaIni"></date-picker>
						            <div v-if="errors && errors.vigencia_ini" 
						            	class="text-danger">
				                        {{ errors.vigencia_ini[0] }}
				                    </div>
				    			</div>

				    			<div class="col-md-3 mb-3">
				    				<label for="vigencia_fin">
				    					Fecha Vigencia Final:
				    				</label>
				    				<date-picker 
				    					id="vigencia_fin"
				    					:disabled="disabled"
				    					class="form-control-sm"
				    					v-model="form.vigenciaFin"></date-picker>
						            <div v-if="errors && errors.vigencia_fin" 
						            	class="text-danger">
				                        {{ errors.vigencia_fin[0] }}
				                    </div>
				    			</div>

				    			<div class="col-md-3 mb-3">
				    				<label for="referencia">
				    					Póliza Referencia:
				    				</label>
				    				<input
				    					id="referencia"
				    					:disabled="disabled"
				    					v-model="form.referencia"
				    					class="form-control form-control-sm"
				    					maxlength="30">
						            <div v-if="errors && errors.referencia" 
						            	class="text-danger">
				                        {{ errors.referencia[0] }}
				                    </div>
				    			</div>

				    			<div class="col-md-3 mb-3" v-if="modal!='create'">
				    				<label>
				    					Estado:
				    				</label>
				    				<select2 
				    					v-model="form.estatus" 
				    					:disabled="disabled">
				    					<option value="V">Vigente</option>
				    					<option value="N">No Vigente</option>
				    				</select2>
						            <div v-if="errors && errors.estatus" 
						            	class="text-danger">
				                        {{ errors.estatus[0] }}
				                    </div>
				    			</div>

				    			<div class="col-md-6 mb-3">
				    				<label>
				    					Mensajero:
				    				</label>
				    				<input
				    					:disabled="true"
				    					class="form-control form-control-sm"
				    					v-model="form.mensajero">
				    			</div>

				    			<div class="col-md-12 mb-3">
				    				<label for="observaciones">
				    					Observaciones:
				    				</label>
				    				<textarea 
				    					id="observaciones"
				    					:disabled="disabled"
				    					v-model="form.observaciones"
				    					class="form-control"
				    					maxlength="250">
				    				</textarea>
						            <div v-if="errors && errors.observaciones" 
						            	class="text-danger">
				                        {{ errors.observaciones[0] }}
				                    </div>
		    					</div>
				    		</div>
	    				</div>
	    			</div>
	    			<div class="card col-md-3">
	    				<div class="card-header border-0">
                            <h3 class="card-title text-center">
                                Montos
                            </h3>
                        </div>
                        <div class="card-body p-0">
                        	<div class="form-row">
		    					<div class="form-row mb-2 w-100">
		    						<div class="col-md-12 mb-3">
			    						<label for="sumaAsegurada">
			    							Suma Asegurada:
			    						</label>
			    						<decimal
			    							id="sumaAsegurada"
			    							:disabled="disabled"
			    							v-model="form.sumaAsegurada"
			    							class="form-control-sm"
			    							min="0"></decimal>
			    						<div v-if="errors && errors.suma_asegurada" 
							            	class="text-danger">
					                        {{ errors.suma_asegurada[0] }}
					                    </div>
						            </div>

						            <div class="col-md-6 mb-3">
						            	<label for="deducible1">
			    							Deducible 1:
			    						</label>
			    						<decimal
			    							id="deducible1"
			    							:disabled="disabled"
			    							v-model="form.deducible1"
			    							class="form-control-sm"
			    							min="0"></decimal>
			    						<div v-if="errors && errors.deducible1" 
							            	class="text-danger">
					                        {{ errors.deducible1[0] }}
					                    </div>
							    	</div>	

							    	<div class="col-md-6 mb-3">
							    		<label for="deducible2">
			    							Deducible 2:
			    						</label>
			    						<decimal
			    							id="deducible2"
			    							:disabled="disabled"
			    							v-model="form.deducible2"
			    							class="form-control-sm"
			    							min="0"></decimal>
			    						<div v-if="errors && errors.deducible2" 
							            	class="text-danger">
					                        {{ errors.deducible2[0] }}
					                    </div>
								    </div>

		    						<div class="col-md-12 mb-3">
			    						<label for="premaNeta">
			    							Prima Neta:
			    						</label>
			    						<decimal
			    							id="premaNeta"
			    							:disabled="disabled"
			    							v-model="form.primaNeta"
			    							class="form-control-sm"
			    							min="0"></decimal>
			    						<div v-if="errors && errors.prima_neta" 
							            	class="text-danger">
					                        {{ errors.prima_neta[0] }}
					                    </div>
									</div>

									<div class="col-md-12 mb-3">
										<label for="primaTotal">
			    							Prima Total:
			    						</label>
			    						<decimal
			    							id="primaTotal"
			    							:disabled="disabled"
			    							v-model="form.primaTotal"
			    							class="form-control-sm"
			    							min="0"></decimal>
			    						<div v-if="errors && errors.prima_total" 
							            	class="text-danger">
					                        {{ errors.prima_total[0] }}
					                    </div>
									</div>

									<div class="col-md-6 mb-3">
		    							<label>
		    								Saldo:
		    							</label>
		    							<copy class="btn bg-secondary text-left text-white btn-block box-shadow" :text="money(form.saldo)">
		    								{{money(form.saldo, true)}}
				    					</copy>
			    					</div>

			    					<div class="col-md-6 mb-3">
		    							<label>
		    								Total Cobrado:
		    							</label>
		    							<copy class="btn bg-dark text-left text-white btn-block box-shadow" :text="money(totalCobrado)">
				    						{{money(totalCobrado, true)}}
				    					</copy>
			    					</div>
		    					</div>
		    				</div>
                        </div>
                        <div class="card-footer bg-gray text-right">
                            <button 
				        		type="button"
				        		class="btn btn-success" 
				        		v-on:click.prevent="updatePolizas"
				        		:disabled="loading">
				        		Actualizar
				        	</button>
                        </div>
	    			</div>
	    		</div>
			</div>
		  	<div class="tab-pane fade p-3" id="bienes" role="tabpanel" aria-labelledby="bienes-tab">
		  		<bien-asegurado :poliza="form.id"></bien-asegurado>
		  	</div>
		  	<div class="tab-pane fade p-3" id="endosos" role="tabpanel" aria-labelledby="endosos-tab">
		  		<polizas-endosos :poliza="form.id"></polizas-endosos>
		  	</div>
			<div class="tab-pane fade p-3" id="cobros-programados" role="tabpanel" aria-labelledby="cobros-programados-tab">
				<polizas-cobros-programados :poliza="form.id"></polizas-cobros-programados>
			</div>
			<div class="tab-pane fade p-3" id="cobros-realizados" role="tabpanel" aria-labelledby="cobros-realizados-tab">
				<polizas-cobros-realizados :poliza="form.id"></polizas-cobros-realizados>
			</div>
			<div class="tab-pane fade p-3" id="logs" role="tabpanel" aria-labelledby="logs-tab">
				<polizas-logs :poliza="form.id"></polizas-logs>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['codigo', 'data'],

		mounted(){
			if (this.dataDefault == null) {
				this.loadDetalle();
			}

			var vm = this;
			$.fn.getDetallePoliza = function () {
				vm.loadDetalle();
			};
		},

		created(){
			if (this.dataDefault != null) {
				this.setData(this.dataDefault);
			}
		},

		data(){
			return {
				loading: false,
				disabled: false,

				modal: false,
				form: {
					id: '',
					poliza: '',
					estatus: '',
					aseguradora: '',
					cliente: '',
					vendedor: '',
					producto: '',
					tipoPoliza: '',
					vigenciaIni: '',
					vigenciaFin: '',
					bienAsegurado: '',
					formaPago: '',
					referencia: '',
					observaciones: '',
					sumaAsegurada: 0,
					deducible1: 0,
					deducible2: 0,
					primaNeta: 0,
					primaTotal: 0,
					saldo: 0,
					totalCobro: 0,
					mensajero: '',
				},

				errors: {},
			}
		},

		methods: {
			loadDetalle: function(){
				this.loading = true;
				var url = 'api/oportunidades/polizas/'+this.poliza;

				axios.get(url)
				.then(response => {
					console.log(response.data)
					this.setData(response.data)
				}).catch(error => {
					console.log(error.response)
				}).then(()=>{
					this.loading = false;
				});
			},
			
			updatePolizas: function(){
				this.errors = {};
				this.loading = true;
				var url = 'api/oportunidades/polizas/'+this.form.id;

				axios.put(url, {
					aseguradora: this.form.aseguradora,
					estatus: this.form.estatus,
					cliente: this.form.cliente,
					vendedor: this.form.vendedor,
					producto: this.form.producto,
					tipo_poliza: this.form.tipoPoliza,
					vigencia_ini: this.form.vigenciaIni,
					vigencia_fin: this.form.vigenciaFin,
					bien_asegurado: this.form.bienAsegurado,
					forma_pago: this.form.formaPago,
					referencia: this.form.referencia,
					observaciones: this.form.observaciones,
					suma_asegurada: this.form.sumaAsegurada,
					deducible1: this.form.deducible1,
					deducible2: this.form.deducible2,
					prima_neta: this.form.primaNeta,
					prima_total: this.form.primaTotal,
				})
				.then(response => {
					this.$toasted.show('La póliza ha sido actualizada.');
				}).catch(error => {
					console.log(error.response);
					if (error.response.status === 422) {
                    	this.errors = error.response.data.errors || {};
                    }
					this.$toasted.show('Error al actualizar póliza.');
				}).then(()=>{
					this.loading = false;
				});
			},

			setData: function(data){
				this.form.id = data.CODIGO_POLIZA;
				this.form.oportunidad = data.CODIGO_OPORTUNIDAD;
				this.oportunidad = data.CODIGO_OPORTUNIDAD;
				this.form.aseguradora = data.CODIGO_ASEGURADORA;
				this.form.estatus = data.ESTATUS;
				this.form.cliente = data.CODIGO_CLIENTE;
				this.form.vendedor = data.CODIGO_VENDEDOR;
				this.form.producto = data.CODIGO_PRODUCTO;
				this.form.tipoPoliza = data.TIPO_POLIZA;
				this.form.vigenciaIni = data.FECHA_VIGENCIA_INI;
				this.form.vigenciaFin = data.FECHA_VIGENCIA_FIN;
				this.form.bienAsegurado = data.BIEN_ASEGURADO;
				this.form.formaPago = data.CODIGO_FORMA_PAGO;
				this.form.referencia = data.CODIGO_POLIZA_REF;
				this.form.observaciones = data.OBSERVACIONES;
				this.form.sumaAsegurada = data.SUMA_ASEGURADA;
				this.form.deducible1 = data.DEDUCIBLE1;
				this.form.deducible2 = data.DEDUCIBLE2;
				this.form.primaNeta = data.PRIMA_NETA;
				this.form.primaTotal = data.PRIMA_TOTAL;
				this.form.saldo = 0;
				this.form.totalCobro = 0;

				if (data.endosos) {
					var total = [];
					var saldo = [];

					Object.entries(data.endosos).forEach(([key, val]) => {
						if (val.cobros_programados != null) {
							total.push(val.cobros_programados.TOTAL || []);
						}
					});

					Object.entries(data.endosos).forEach(([key, val]) => {
						if (val.cobros_programados != null) {
							saldo.push(val.cobros_programados.SALDO || []);
						}
					});

					this.form.totalCobro = total.reduce(function(total, num){
						return (parseFloat(total) || 0) + (parseFloat(num) || 0);
					}, 0);

					this.form.saldo = saldo.reduce(function(total, num){
						return (parseFloat(total) || 0) + (parseFloat(num) || 0);
					}, 0);
				}

				if (data.cliente) {
					this.form.mensajero =  data.cliente.mensajero ? data.cliente.mensajero.NOMBRE_MENSAJERO : 'No definido';
				}else{
					this.form.mensajero = 'No definido';
				}
			},
		},

		computed: {
            poliza: function(){
            	return this.codigo;
            },

            totalCobrado: function(){
            	return this.form.totalCobro - this.form.saldo;
            },

            dataDefault: function(){
            	return JSON.parse(this.data);
            }
        },

        /*watch: {
        	poliza: function(val){
        		this.loadDetalle();
        	},

        	dataDefault: function(val){
        		console.log('change')
        	}
        }*/
	}
</script>